import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Table, Form, Button, Input, Row, Col, Radio
  , Select, Collapse, Icon, InputNumber,
} from 'antd';
import { toJS } from 'mobx';
import AppDatasBody from '../util/AppDatasBody';
import isEmpty from 'lodash/isEmpty';
const store = ['priceStore', 'initStore'];
const createForm = Form.create;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const Panel = Collapse.Panel;

@inject(...store)
@observer
class Price extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      titles: ["应用名称", "应用编号", "是否收费", "参考价", "行业", "应用类别", "浏览器兼容",
        "ec版本兼容", "数据库兼容", "获取次数（一个订单可能获取多次）", "详情描述"],
      columns: [
        { title: '应用编号', dataIndex: 'productNumber', key: 'productNumber', width: '8%' },
        { title: '应用名称', dataIndex: 'productName', key: 'productName', width: '14%' },
        { title: '行业', dataIndex: 'tradeName', key: 'tradeName', width: '8%' },
        { title: '应用类别', dataIndex: 'productTypeName', key: 'productTypeName', width: '12%' },
        { title: '浏览器兼容', dataIndex: 'inter', key: 'inter', width: '8%' },
        { title: 'ec版本兼容', dataIndex: 'ec', key: 'ec', width: '10%' },
        { title: '数据库兼容', dataIndex: 'database', key: 'database', width: '10%' },
        { title: '获取次数', dataIndex: 'downCount', key: 'downCount', width: '10%' },
        { title: '详情描述', dataIndex: 'productDesc', key: 'productDesc', width: '8%' },
      ],
      isFreeOptions: [
        { label: '全部', value: '-1' },
        { label: '免费', value: '1' },
        { label: '收费', value: '0' },
      ],
      ifFbOptions: [
        { label: '全部', value: '-1' },
        { label: '非标', value: '1' },
        { label: '标准', value: '0' },
      ],
      pathname: '',
      activeKey: []
    }
  }

  async componentWillUnmount() {
  }

  async componentDidMount() {
    const { priceStore } = this.props;
    await  priceStore.getPriceInfoList();
  }

  componentWillReceiveProps(nextProps) {
    //解决
    //从应用报价(app/price)跳转至报价维护（manager/price）
    //用的统一组件(Price),组件中table的自定义列不会重新渲染
    //的问题
    if('location' in nextProps && nextProps.location.pathname) {
      this.setState({pathname: nextProps.location.pathname})
    }
  }

  render() {
    let { columns, ifFbOptions, activeKey } = this.state;
    let { priceStore, location } = this.props;
    let {
      priceInfoList, page, getPriceInfoList, loading, setPage, setSearchValue
      , resetSearchValue, searchValue, editPriceInfoList, setPriceInfoList
    } = priceStore;
    const {
      productName, ifFb, productNumber, productTypeName, tradeName
      , inter, ec, database, minPrice, maxPrice,
    } = searchValue;
    priceInfoList = toJS(priceInfoList);
    // let scroll = priceInfoList.length > 0 ? { x: 1300 } : {};
    const freeCol = {
      title: '是否收费', dataIndex: 'isFree', key: 'isFree', width: '6%',
      render: (text, record) => {
        const pathname = this.state.pathname !== '' ? this.state.pathname : location.pathname;
        const shouldEdit = pathname === 'manager/price';
        return (
          shouldEdit && record.auth && (record.auth.admin || record.auth.edit) ? (
            <Select value={text} className='price-table-select'
              onChange={value => editPriceInfoList(record, { isFree: value })}>
              <Option value='0'>是</Option>
              <Option value='1'>否</Option>
            </Select>
          ) : (
            <span className='price-span-select'>{text === '0' ? '是' : '否'}</span>
          )
        )
      }

    };
    const priceCol = {
      title: '参考价', dataIndex: 'productPrice', key: 'productPrice', width: '6%',
      render: (text, record) => {
        const pathname = this.state.pathname !== '' ? this.state.pathname : location.pathname;
        const shouldEdit = pathname === 'manager/price';
        return (
          shouldEdit && record.auth && (record.auth.admin || record.auth.edit) ? (
            <div className='price-input'>
              <Input value={text}
                onChange={e => setPriceInfoList(record, { productPrice: e.target.value })}
                onPressEnter={e => editPriceInfoList(record, { productPrice: e.target.value })}
              />
              <span>元</span>
            </div>
          ) : (
            <span>{text}</span>
          )
        )
      }
    };
    if (!columns.find(value => freeCol.key === value.key)) columns.splice(2, 0, freeCol);
    if (!columns.find(value => priceCol.key === value.key)) columns.splice(3, 0, priceCol);
    const header = (
      <Row>
        <Col span={8}>
          <Col span={8} className='price-label'> <label>应用编号：</label></Col>
            <Col span={14}>
              <Input placeholder='请输入应用编号' value={productNumber}
                     onChange={e => setSearchValue({ productNumber: e.target.value })} />
            </Col>
        </Col>
        <Col span={8}>
          <Col span={8} className='price-label'> <label>应用名称：</label></Col>
          <Col span={14}>
            <Input placeholder='请输入应用名称' value={productName}
                   onChange={e => setSearchValue({ productName: e.target.value })} />
          </Col>
        </Col>
        <Col span={8} style={{position: 'relative'}}>
          <Button type="primary"
                  style={{ marginRight: 10 }}
                  onClick={getPriceInfoList}>搜索</Button>
          <Button type="ghost"
                  style={{ marginRight: 10 }}
                  onClick={() => resetSearchValue()}>重置</Button>
          {!!localStorage.me ?
            <Button type="primary" icon="download" loading={loading}
                    href={window.server + "/product/price/export"}>导出</Button>
                  : ''}
          {
            isEmpty(activeKey) ? <Icon type="down" className='price-icon-arrow' onClick={() => this.setState({activeKey: ['1']})}/>
              : <Icon type="up" className='price-icon-arrow'  onClick={() => this.setState({activeKey: []})}/>
          }
        </Col>
      </Row>
    );
    return (
      <div className='price'>
        <AppDatasBody location={location}>
          <div className="cs-search-mylist">
            <Collapse bordered={false} activeKey={activeKey}>
              <Panel header={header} key="1" style={{border: 0}} showArrow={false}>
                <Row className='cs-search-mylist-single'>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>行业：</label></Col>
                    <Col span={14}>
                      <Input placeholder='请输入行业' value={tradeName}
                        onChange={e => setSearchValue({ tradeName: e.target.value })} />
                    </Col>
                  </Col>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>应用类型：</label></Col>
                    <Col span={14}>
                      <Input placeholder='请输入应用类型' value={productTypeName}
                        onChange={e => setSearchValue({ productTypeName: e.target.value })} />
                    </Col>
                  </Col>
                  <Col span={8}>
                    <Row>
                    <Col span={8} className='price-label'> <label>是否非标产品：</label></Col>
                  <Col span={16} className='price-content'>
                    <RadioGroup options={ifFbOptions} value={ifFb}
                  onChange={e => setSearchValue({ ifFb: e.target.value })} />
                  </Col>
                  </Row>
                  </Col>
                </Row>
                <Row className='cs-search-mylist-single'>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>应用价格：</label></Col>
                    <Col span={14}>
                      <InputNumber value={minPrice} min={0} precision={2} onChange={(v) => setSearchValue({ minPrice: v || '' })}/>
                      <span style={{ margin: '0 10px' }}>-</span>
                      <InputNumber value={maxPrice} min={0} precision={2} onChange={(v) => setSearchValue({ maxPrice: v || '' })}/>
                    </Col>
                  </Col>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>浏览器兼容：</label></Col>
                    <Col span={14}>
                      <Input placeholder='请输入浏览器兼容' value={inter}
                        onChange={e => setSearchValue({ inter: e.target.value })} />
                    </Col>
                  </Col>
                </Row>
                <Row className='cs-search-mylist-single'>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>ec兼容：</label></Col>
                    <Col span={14}>
                      <Input placeholder='请输入ec兼容' value={ec}
                        onChange={e => setSearchValue({ ec: e.target.value })} />
                    </Col>
                  </Col>
                  <Col span={8}>
                    <Col span={8} className='price-label'> <label>数据库兼容：</label></Col>
                    <Col span={14}>
                      <Input placeholder='请输入数据库兼容' value={database}
                        onChange={e => setSearchValue({ database: e.target.value })} />
                    </Col>
                  </Col>
                {/*<Col span={8}>
                    <Row>
                      <Col span={8} className='price-label'> <label>是否免费：</label></Col>
                      <Col span={16} className='price-content'>
                        <RadioGroup options={isFreeOptions} value={isFree}
                                    onChange={e => setSearchValue({isFree: e.target.value})}/>
                      </Col>
                    </Row>
                  </Col>*/}
                </Row>
              </Panel>
            </Collapse>
          </div>
          <Table columns={columns}
            dataSource={priceInfoList}
            loading={loading}
            className='list-table'
            // scroll={scroll}
            pagination={{
              ...page,
              showTotal: (total) => `共${total}条`,
              showSizeChanger: true,
              showQuickJumper: true,
              onChange: (pageNum, pageSize) => {
                setPage({ current: pageNum, pageSize: pageSize });
                getPriceInfoList();
              },
              onShowSizeChange: (current, size) => {
                setPage({ current: 1, pageSize: size });
                getPriceInfoList();
              }
            }}
          />
        </AppDatasBody>
      </div>
    );
  }
}
Price = createForm()(Price);
export default Price;


// WEBPACK FOOTER //
// ./src/components/price/Price.js